import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const brokerApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'brokerApi',
  endpoints: (builder) => ({
    getBrokerServicesAll: builder.query<any, void>({
      query: () => ({ url: '/certification/cabinet/services/category/' }),
    })
  }),
})

export const {
  useGetBrokerServicesAllQuery
} = brokerApi

export const brokerSlice = createSlice({
  name: 'broker',
  initialState: {
    broker: {} as BrokerServices
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      brokerApi.endpoints.getBrokerServicesAll.matchFulfilled,
      (state, { payload, meta: { arg: { originalArgs } }  }) => {
        state.broker = { ...state.broker, brokerServicesAll: payload.results }
      }
    )
  },
})
